<num-modal-window (saveButtonSelected)="saveCriterion()" (cancelButtonSelected)="closeDialog()">
  <div class="container">
    <ng-container *ngIf="criterion.getTimeRestriction()">
      <div class="background">
        <num-edit-time-restriction
          [timeRestriction]="criterion.getTimeRestriction()"
          (timeRestrictionChanged)="updateTimeRestriction($event)"
        >
        </num-edit-time-restriction>
      </div>
    </ng-container>
    <ng-container *ngIf="attributeFilters.length > 0">
      <div style="display: flex; flex: 1; min-height: 0; width: 100%" class="background">
        <mat-tab-group>
          <div *ngFor="let attributeFilter of attributeFilters">
            <mat-tab
              class="attribute-filter-container"
              label="{{ attributeFilter.getDisplay() | displayTranslation }}"
            >
              <num-attribute-filter
                [attributeFilter]="attributeFilter"
                (attributeFilterChange)="updateAttributeFilter($event)"
              >
              </num-attribute-filter>
            </mat-tab>
          </div>
        </mat-tab-group>
      </div>
    </ng-container>
    <ng-container *ngIf="criterion.getValueFilters().length > 0">
      <div *ngFor="let valueFilter of criterion.getValueFilters()" class="background">
        <num-value-filter
          [valueFilter]="valueFilter"
          (valueFilterChange)="updateValueFilter($event)"
        >
        </num-value-filter>
      </div>
    </ng-container>
    <ng-container *ngIf="criterion.getTermCodes().length > 1">
      <div class="termcode-container background">
        <num-edit-termcode
          class="height-100"
          [termCodes]="criterion.getTermCodes()"
          [context]="criterion.getContext()"
          (changedTermCodes)="updateTermCodes($event)"
        >
        </num-edit-termcode>
      </div>
    </ng-container>
  </div>
</num-modal-window>
